import IGiaoDucCourseDetailAPI from '@/apis/business/MISAStore/igiaoduc-course-detail-api.js'

export default {

  namespaced: true,

  state: {
    iGiaoDucCourseDetails: []
  },

  getters: {},

  mutations: {

    setIGiaoDucCourseDetail (state, iGiaoDucCourseDetails) {
      state.iGiaoDucCourseDetails = iGiaoDucCourseDetails
    }
  },

  actions: {

    getIGiaoDucCourseDetail (context, params) {
      return new Promise((resolve, reject) => {
        IGiaoDucCourseDetailAPI.getAsync(`course/${params}`)
          .then((res) => {
            context.commit('setIGiaoDucCourseDetail', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author PVThang
     * @description Lấy danh sách CourseDetail theo courseID
     * @param {*} context
     * @param {*} courseID
     * @returns
     */
    async getManyByCourseID (context, courseID) {
      const stateData = context.state.iGiaoDucCourseDetails
      if (stateData && stateData[0]?.CourseID === courseID) {
        return {
          Data: stateData
        }
      }

      return await IGiaoDucCourseDetailAPI.getAsync(`course/${courseID}`)
    }
  }
}
